import { Col, Row } from 'reactstrap';
import styled, { withTheme } from 'styled-components';

export const AddressDetailsContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: center;
    margin: 0px 0px 20px 0px;
    width: 100%;
`;

export const BtnContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;
BtnContainer.displayName = 'BtnContainer';

export const ColStyled = styled(Col)`
    margin-bottom: 15px;
`;
ColStyled.displayName = 'ColStyled';

export const Container = styled.div`
    max-height: calc(100vh - 286px);
    overflow: auto;
    padding: 10px 10% 100px 10%;

    @media (max-width: 1024px) {
        padding: 10px 10px 100px 10px;
    }
`;
Container.displayName = 'Container';

const HeaderComponent = styled.div`
    align-items: center;
    background-color: ${ ({ theme: { disabledColor } }) => disabledColor };
    box-sizing: border-box;
    color: ${ ({ theme: { textColor } }) => textColor };
    cursor: pointer;
    display: flex;
    font-size: 18px;
    font-weight: 400;
    padding: 5px 15px;
    width: 100%;
`;
export const Header = withTheme(HeaderComponent);
Header.displayName = 'Header';

export const RowStyled = styled(Row)`
    margin-bottom: ${ ({ marginbottom }) => marginbottom ?? '0px' };
    margin-top: ${ ({ margintop }) => margintop ?? '0px' };
`;
RowStyled.displayName = 'RowStyled';

export const GridCol = styled.div`
    margin: ${ ({ margin }) => margin || '0px 10px' };
    flex: ${ ({ flex }) => flex || 1 } ;
`;
GridCol.displayName = 'GridCol';

const SubheaderComponent = styled.div`
    padding: 30px 20px 10px 25px;
    border-bottom: 1px solid ${ ({ theme: { disabledColor } }) => disabledColor };
`;
export const Subheader = withTheme(SubheaderComponent);
Subheader.displayName = 'Subheader';

const TextComponent = styled.span`
    color: ${ ({ theme: { textColor }, color }) => textColor || color };
    font-size: ${ ({ size }) => size || '16px' };
    font-weight: ${ ({ weight }) => weight || '400' };
    text-align: center;
`;
export const Text = withTheme(TextComponent);
Text.displayName = 'Text';

const TitleComponent = styled(Text) `
    font-size: 21px;
    font-weight: 500;
    margin: 0.83em 0px;
`;
export const Title = withTheme(TitleComponent);
Title.displayName = 'Title';
